import { MB } from '../constants/fileSize';
import { IUploadFile } from '../interfaces/IUploadFile';

export const isFilesSizeValid = (files: IUploadFile[], inputSize = 0) => {
  const existedFilesSize = files.reduce((size, file) => {
    if (typeof file.fileSize === 'string') {
      return size + parseInt(file.fileSize, 10);
    }
    return size + file.fileSize;
  }, 0);
  return existedFilesSize + inputSize < 40 * MB;
};
